module.exports = __webpack_public_path__ + "static/media/user-update.44e3199e.png";